import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export interface WhatsappState {
  isOfficialApiActivationOpen: boolean;
  isConnected: boolean | null | undefined;
  isFallbackConnected: boolean | null | undefined;
  isConnectToWhatsappDialogOpen: boolean;
  isUpdateWhatsAppNumberDialogOpen: boolean;
  toastId: string | number | null;
}

const initialState: WhatsappState = {
  isOfficialApiActivationOpen: false,
  isConnected: undefined,
  isFallbackConnected: undefined,
  isConnectToWhatsappDialogOpen: false,
  isUpdateWhatsAppNumberDialogOpen: false,
  toastId: null,
};

const whatsappSlice = createSlice({
  name: 'whatsapp',
  initialState,
  reducers: {
    setIsOfficialApiActivationOpen: (state, action: PayloadAction<boolean>) => { state.isOfficialApiActivationOpen = action.payload; },
    setIsConnected: (state, action: PayloadAction<boolean | null>) => {
      state.isConnected = action.payload;
    },
    setIsFallbackConnected: (
      state,
      action: PayloadAction<boolean | null>
    ) => {
      state.isFallbackConnected = action.payload;
    },
    setIsConnectToWhatsappDialogOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isConnectToWhatsappDialogOpen = action.payload;
    },
    setIsUpdateWhatsAppNumberDialogOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isUpdateWhatsAppNumberDialogOpen = action.payload;
    },
    showToast: (state, action: PayloadAction<{ toast: React.ReactNode, toastId: string }>) => {
      state.toastId = toast(action.payload.toast, {
        toastId: action.payload.toastId,
        position: 'top-right',
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        className: 'toast-warning-custom',
      });
    },
    closeToast: (state) => {
      if (state.toastId) {
        toast.dismiss(state.toastId);
        state.toastId = null;
      }
    },
  },
});

export const {
  setIsOfficialApiActivationOpen,
  setIsUpdateWhatsAppNumberDialogOpen,
  setIsConnectToWhatsappDialogOpen,
  setIsConnected,
  setIsFallbackConnected,
  showToast,
  closeToast,
} = whatsappSlice.actions;

export default whatsappSlice.reducer;
